export const GET_ALL_TABLE_SETTINGS = "GET_ALL_TABLE_SETTINGS";
export const ADD_TABLE_SETTINGS = "ADD_TABLE_SETTINGS";
export const GET_THEME_PREFERENCES = "GET_THEME_PREFERENCES";
export const UPDATE_THEME_PREFERENCES = "UPDATE_THEME_PREFERENCES";
